import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as authActions from 'redux/modules/auth';
var LoginSuccess = (_dec = connect(function (state) {
  return {
    user: state.auth.user
  };
}, authActions), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(LoginSuccess, _Component);

  var _super = _createSuper(LoginSuccess);

  function LoginSuccess() {
    _classCallCheck(this, LoginSuccess);

    return _super.apply(this, arguments);
  }

  _createClass(LoginSuccess, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          user = _this$props.user,
          logout = _this$props.logout;
      return user && /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement("h1", null, "Login Success"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Hi, ", user.email, ". You have just successfully logged in, and were forwarded here by", ' ', /*#__PURE__*/React.createElement("code", null, "componentWillReceiveProps()"), " in ", /*#__PURE__*/React.createElement("code", null, "App.js"), ", which is listening to the auth reducer via redux ", /*#__PURE__*/React.createElement("code", null, "@connect"), ". How exciting!"), /*#__PURE__*/React.createElement("p", null, "The same function will forward you to ", /*#__PURE__*/React.createElement("code", null, "/"), " should you chose to log out. The choice is yours..."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-danger",
        onClick: logout
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-sign-out"
      }), " Log Out"))));
    }
  }]);

  return LoginSuccess;
}(Component), _defineProperty(_class2, "propTypes", {
  user: PropTypes.object,
  logout: PropTypes.func
}), _temp)) || _class);
export { LoginSuccess as default };